import './Evolve.css';
import evolveImg from '../Assets/our.jpg';
import { FaShieldAlt, FaLightbulb } from "react-icons/fa";

function Evolve() {
  return (
    <div className="evolve-container">
      
      <h2 className="evolve-title">OUR EVOLUTION</h2>
      <p className="evolve-sub-title">
        Discover how Amy Floris has grown from a small consulting group to an industry leader in BIS certification.
      </p>

     
      <div className="evolve-section">
  
        <div className="evolve-image">
          <img src={evolveImg} alt="Our Evolution" />
        </div>

        
        <div className="evolve-description-section">
          <h3 className="evolve-dis-title">Our Story</h3>
          <p className="evolve-description">
            Founded by visionary Chemical Engineer with two decades of expertise in BIS Certification,
            Amy Floris Services emerged as trailblazers by assessing the practical problems faced by licensees
            and providing best-in-class services as solutions. Our journey began with a mission to redefine
            quality standards of the manufacturing industry through continuous assessment, giving quantifiable
            change in product quality. We are the first in India and still the only one to provide SaaP for 200+
            clients across India.
          </p>
          <p className="evolve-description">
            Not stopping after mastering the art of BIS certification acquisition, we also excel in designing,
            manufacturing, and trading testing equipment required for BIS certification through our parent
            company E CUBE INTERNATIONAL.
          </p>

      
          <div className="evolve-stats">
            <div className="stat-card">
              <div className="stat-value">20+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">200+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
          </div>
        </div>
      </div>

 
      <div className="mission-cards">
        <div className="mission-card">
          <div className="mission-icon mission-icon-pink">
            <FaShieldAlt />
          </div>
          <h3>OUR MISSION</h3>
          <p>
          TO EMPOWER THE SME INDUSTRY BY PROVIDING TRAINING & TOOLS FOR OBTAINING AND MAINTAINING BIS CERTIFICATIONS.
          </p>
        </div>

        <div className="mission-card">
          <div className="mission-icon mission-icon-green">
            <FaLightbulb />
          </div>
          <h3>OUR VISION</h3>
          <p>
          TO BE INDIA’S MOST TRUSTABLE, PREFERABLE, COST EFFECTIVE, EFFICIENT & WELL KNOWN SERVICE PROVIDER.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Evolve;
